import { useTranslation } from 'react-i18next'
import { useAppDispatch, useAppSelector } from '../../store/hooks/hooks'
import { setActiveTab } from '../../store/slices/appSlice'
import './CategoryTabs.css'

export const CategoryTabs = () => {
	const dispatch = useAppDispatch()
	const tabs = useAppSelector(state => state.app.tabs)
	const activeTab = useAppSelector(state => state.app.activeTab)
	const { t } = useTranslation()

	return (
		<nav className="category-tabs">
			{tabs.map(tab => (
				<button
					type="button"
					key={tab}
					className={`category-tabs__tab${activeTab === tab ? ' category-tabs__tab--active' : ''}`}
					onClick={() => dispatch(setActiveTab(tab))}
				>
					{t(`tabs.${tab}`)}
				</button>
			))}
		</nav>
	)
}